import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import { useTagsSelector } from '../hooks/useTagsSelector';
import { NUM_MAX_SURVEY_TAGS } from '../config/constants';

export default function TagsSelectorDialog() {
  const {
    isOpen,
    close,
    saveTags,
    tags,
    selectedTags,
    onToggleTag,
    deleteTag,
  } = useTagsSelector();

  if (!isOpen) {
    return null;
  }

  return (
    <Dialog
      open={isOpen}
      onClose={close}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">
        {/* <Typography>Select Tags (Maximum of 5)</Typography> */}
        <Typography>Select Tag</Typography>
        <IconButton
          onClick={close}
          aria-label="close"
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ padding: 2, minWidth: 400 }}>
        <Stack direction="column">
          <Box>
            {tags.map((tag) => (
              <Chip
                disabled={
                  selectedTags.length >= NUM_MAX_SURVEY_TAGS &&
                  !selectedTags.find((selectedTag) => selectedTag.id === tag.id)
                }
                key={tag.id}
                label={tag.label}
                sx={{
                  m: 1,
                  border: selectedTags.find(
                    (selectedTag) => selectedTag.id === tag.id,
                  )
                    ? '1px solid transparent'
                    : 1,
                }}
                onClick={() => {
                  onToggleTag(tag);
                }}
                variant={
                  selectedTags.find((selectedTag) => selectedTag.id === tag.id)
                    ? 'filled'
                    : 'outlined'
                }
                color="primary"
                onDelete={!tag.core ? () => deleteTag(tag) : undefined}
              />
            ))}
          </Box>
          <Divider sx={{ my: 2 }} />
          <Stack>
            <AddTagInput />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" justifyContent="space-between" sx={{ flex: 1 }}>
          <Button onClick={saveTags}>Save</Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}

function AddTagInput() {
  const { addTag } = useTagsSelector();
  const [label, setLabel] = useState('');
  return (
    <Stack spacing={1} direction="row">
      <TextField
        placeholder="Add a new tag"
        value={label}
        onChange={(event) => setLabel(event.target.value)}
      />
      <Button
        sx={{ mt: 1 }}
        variant="outlined"
        disabled={!label.trim()}
        onClick={(event) => {
          event.preventDefault();
          addTag(label);
          setLabel('');
        }}
      >
        Add Tag
      </Button>
    </Stack>
  );
}
